import { formatDateTime } from '../../i18n/format';
import { i18n } from '../../i18n/i18n';

/** Wall-clock "HH:mm" in the active language's digits; stays 24-hour like the API value. */
export function formatLocalTime(value: string): string {
  const [hours, minutes] = value.split(':').map(Number);
  return formatDateTime(new Date(2000, 0, 1, hours ?? 0, minutes ?? 0), {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
}

/** Local wall-clock window label (supports overnight wrap). */
export function formatLocalWindow(
  startLocalTime: string,
  endLocalTime: string,
  style: 'arrow' | 'range' = 'arrow',
): string {
  const values = { start: formatLocalTime(startLocalTime), end: formatLocalTime(endLocalTime) };
  if (startLocalTime > endLocalTime) {
    return style === 'arrow'
      ? i18n.t('schedule:window.arrowOvernight', values)
      : i18n.t('schedule:window.rangeOvernight', values);
  }
  return style === 'arrow'
    ? i18n.t('schedule:window.arrow', values)
    : i18n.t('schedule:window.range', values);
}
